var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "mobile-back",
      attrs: { "data-link": "menu", type: "button" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "19",
            height: "10",
            viewBox: "0 0 19 10",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M18.5024 0.193236C18.2448 -0.0644125 17.8261 -0.0644125 17.5684 0.193236L9.35588 8.4219L1.12721 0.193236C0.869565 -0.0644125 0.450886 -0.0644125 0.193237 0.193236C-0.0644123 0.450885 -0.0644123 0.869565 0.193237 1.12721L8.87279 9.80676C9.00161 9.93559 9.16264 10 9.33978 10C9.50081 10 9.67794 9.93559 9.80676 9.80676L18.4863 1.12721C18.7601 0.869565 18.7601 0.450885 18.5024 0.193236Z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }